module.exports = __webpack_public_path__ + "static/logo.bfe09f6810a8.png";